import { Routes } from "@angular/router";

export const authRoutes: Routes = [
  {
    path: "",
    loadComponent: () =>
      import("@pages/auth/components/login/login.component").then(
        (m) => m.default,
      ),
  },
  {
    path: "olvido",
    loadComponent: () =>
      import("@pages/auth/components/olvido/olvido.component").then(
        (m) => m.default,
      ),
  },
  {
    path: "verificar",
    loadComponent: () =>
      import("@pages/auth/components/verificar/verificar.component").then(
        (m) => m.default,
      ),
  },
];